<template>
  <b-modal
    id="modalCreateEditModeloProjeto"
    size="xl"
    :title="textModal"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('closeModal', false)"
  >
    <form @submit.prevent="save">
      <div class="col-lg-12">
        <b-tabs
          justified
          nav-class="nav-tabs-custom"
          content-class="p-3 text-muted"
        >
          <b-tab active>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Dados</span>
            </template>
            <!-- NOME DO MODELO DE PEÇA -->
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label
                  >Nome do modelo de projeto:
                  <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.modeloProjeto.titulo.$error }"
                  placeholder="Nome do modelo de projeto"
                  v-model="$v.modeloProjeto.titulo.$model"
                />
                <span
                  v-if="!$v.modeloProjeto.titulo.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="!$v.modeloProjeto.titulo.minLength"
                  class="invalid-feedback"
                >
                  O nome da modelo de projeto deve possuir pelo menos 3
                  caracteres
                </span>
              </div>
            </div>

            <!-- DESCRIÇÃO DO PROJETO -->
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label>Descrição:</label>
                <ckeditor
                  v-model="modeloProjeto.descricao"
                  :editor="editor"
                ></ckeditor>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-sm-6">
                <p>Padrão: <span class="text-danger">*</span></p>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="padraoNao"
                    value="0"
                    v-model="modeloProjeto.padrao"
                  />
                  <label class="form-check-label" for="padraoNao"> Não </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="padraoSim"
                    value="1"
                    v-model="modeloProjeto.padrao"
                  />
                  <label class="form-check-label" for="padraoSim"> Sim </label>
                </div>
              </div>
              <div v-if="modeloProjetoId" class="form-group col-sm-6">
                <p>Status: <span class="text-danger">*</span></p>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="statusInativo"
                    value="0"
                    v-model="modeloProjeto.status"
                  />
                  <label class="form-check-label" for="statusInativo">
                    Inativo
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="statusAtivo"
                    value="1"
                    v-model="modeloProjeto.status"
                  />
                  <label class="form-check-label" for="statusAtivo">
                    Ativo
                  </label>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">Tarefas</span>
            </template>
            <div role="tablist">
              <draggable class="list-group" group="tasks" :list="tarefas">
                <div
                  v-for="(tarefa, index) in tarefas"
                  :key="index"
                  class="card task-box"
                >
                  <div
                    class="progress progress-sm animated-progess"
                    style="height: 3px"
                  >
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      variant="success"
                    ></div>
                  </div>
                  <b-card no-body class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <div class="form-row">
                        <div class="form-group col-sm-1">
                          <br />
                          <a
                            v-b-toggle="'accordion-' + index"
                            class="btn btn-lg btn-outline-info btn-rounded"
                            href="javascript: void(0);"
                            >{{ index + 1 }}</a
                          >
                        </div>
                        <div class="form-group col-sm-10">
                          <label>Título: </label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Título da tarefa"
                            :name="'tarefas[' + index + '].[titulo]'"
                            :id="'tarefas[' + index + ']'"
                            v-model="tarefas[index].titulo"
                          />
                        </div>
                        <div class="form-group col-sm-1">
                          <br />
                          <button
                            type="button"
                            @click="deleteTarefa(index)"
                            class="btn btn-lg btn-outline-danger"
                            title="Adicionar Tarefa"
                          >
                            <i class="bx ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + index"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    ></b-collapse>
                    <b-collapse
                      :id="'accordion-' + index"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <!-- DESCRIÇÃO DO PROJETO -->
                        <div class="form-row">
                          <div class="form-group col-sm-12">
                            <label>Descrição:</label>
                            <ckeditor
                              :name="'tarefas[' + index + '].[descricao]'"
                              :id="'tarefas[' + index + ']'"
                              v-model="tarefas[index].descricao"
                              :editor="editor"
                            ></ckeditor>
                          </div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </draggable>
              <div>
                <button
                  type="button"
                  @click="addTarefa()"
                  class="btn btn-primary"
                  title="Adicionar rasgadinha"
                >
                  <i class="bx ri-add-line"></i> Nova Tarefa
                </button>
              </div>
            </div>
          </b-tab>

          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">Briefing</span>
            </template>
            <div role="tablist">
              <draggable class="list-group" group="tasks" :list="briefing">
                <div
                  v-for="(item, index) in briefing"
                  :key="index"
                  class="card task-box"
                >
                  <div
                    class="progress progress-sm animated-progess"
                    style="height: 3px"
                  >
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      variant="success"
                    ></div>
                  </div>
                  <b-card no-body class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <div class="form-row">
                        <div class="form-group col-sm-1">
                          <br />
                          <a
                            v-b-toggle="'accordion-' + index"
                            class="btn btn-lg btn-outline-info btn-rounded"
                            href="javascript: void(0);"
                            >{{ index + 1 }}</a
                          >
                        </div>

                        <div class="form-group col-sm-10">
                          <label>Descrição do item:</label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Digite a descrição da pergunta"
                            :name="'briefing[' + index + '].[descricao_item]'"
                            :id="'briefing[' + index + ']'"
                            v-model="briefing[index].descricao_item"
                            autocomplete="off"
                          />
                        </div>
                        <div class="form-group col-sm-1">
                          <br />
                          <button
                            type="button"
                            @click="deleteBriefing(index)"
                            class="btn btn-lg btn-outline-danger"
                            title="Adicionar item"
                          >
                            <i class="bx ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + index"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    ></b-collapse>
                    <b-collapse
                      :id="'accordion-' + index"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                    </b-collapse>
                  </b-card>
                </div>
              </draggable>
              <div>
                <button
                  type="button"
                  @click="addBriefing()"
                  class="btn btn-primary"
                  title="Adicionar rasgadinha"
                >
                  <i class="bx ri-add-line"></i> Adicionar pergunta
                </button>
              </div>
            </div>
          </b-tab>

          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">Peças</span>
            </template>
            <div role="tablist">
              <draggable class="list-group" group="tasks" :list="pecas">
                <div
                  v-for="(peca, index) in pecas"
                  :key="index"
                  class="card task-box"
                >
                  <div
                    class="progress progress-sm animated-progess"
                    style="height: 3px"
                  >
                    <div
                      class="progress-bar bg-info"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      variant="success"
                    ></div>
                  </div>
                  <b-card no-body class="mb-1 shadow-none">
                    <b-card-header header-tag="header" role="tab">
                      <div class="form-row">
                        <div class="form-group col-sm-1">
                          <br />
                          <a
                            v-b-toggle="'accordion-' + index"
                            class="btn btn-lg btn-outline-info btn-rounded"
                            href="javascript: void(0);"
                            >{{ index + 1 }}</a
                          >
                        </div>

                        <div class="form-group col-sm-10">
                          <label
                            >Modelo de peça:
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            :name="'pecas[' + index + '].modelo_peca_id'"
                            :id="'pecas[' + index + ']'"
                            v-model="pecas[index].modelo_peca_id"
                          >
                            <option value="">Selecione uma peça:</option>
                            <option
                              v-for="peca in modelosPecas"
                              :key="peca.id"
                              :value="peca.id"
                              :title="peca.titulo"
                            >
                              {{ peca.titulo }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group col-sm-1">
                          <br />
                          <button
                            type="button"
                            @click="deletePeca(index)"
                            class="btn btn-lg btn-outline-danger"
                            title="Adicionar item"
                          >
                            <i class="bx ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + index"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    ></b-collapse>
                    <b-collapse
                      :id="'accordion-' + index"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                    </b-collapse>
                  </b-card>
                </div>
              </draggable>
              <div>
                <button
                  type="button"
                  @click="addPeca()"
                  class="btn btn-primary"
                  title="Adicionar rasgadinha"
                >
                  <i class="bx ri-add-line"></i> Adicionar modelo de peça
                </button>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <hr />
      <div class="modal-footer-custom">
        <button
          type="button"
          class="btn btn-secondary"
          title="Cancelar"
          @click="$emit('closeModal', false)"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :title="textModal"
          :disabled="$v.$invalid || disableButton"
        >
          <i
            v-if="disableButton"
            class="spinner-grow spinner-grow-custom text-wither"
          />
          <span v-else>{{ textModal }}</span>
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import draggable from 'vuedraggable'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'CreateEditModeloProjetoModal',
  props: {
    modeloProjetoId: {
      type: String,
      default: null,
    },
  },
  components: { ckeditor: CKEditor.component, draggable },
  data() {
    return {
      modeloProjeto: {
        titulo: '',
        descricao: '',
        padrao: '',
      },
      tarefas: [],
      pecas: [],
      briefing: [],
      users: [],
      modelosPecas: null,
      editor: ClassicEditor,
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.modeloProjetoId
        ? 'Atualizar modelo de projeto'
        : 'Cadastrar modelo de projeto'
    },
  },

  methods: {
    addPeca() {
      this.pecas.push({
        modelo_peca_id: '',
      })
    },
    addBriefing() {
      this.briefing.push({
        descricao_item: '',
      })
    },
    addTarefa() {
      this.tarefas.push({
        titulo: 'NOVA TEREFA [EDITAR]',
        descricao: '',
      })
    },
    deleteTarefa(index) {
      this.tarefas.splice(index, 1)
    },
    deletePeca(index) {
      this.pecas.splice(index, 1)
    },
    deleteBriefing(index) {
      this.briefing.splice(index, 1)
    },

    async getModeloProjeto() {
      try {
        this.modeloProjeto = await this.$store.dispatch(
          'getModeloProjeto',
          this.modeloProjetoId,
        )
        this.tarefas = await this.$store.dispatch(
          'getTarefasByModeloProjeto',
          this.modeloProjetoId,
        )
        this.pecas = await this.$store.dispatch(
          'getModelosPecasByModeloProjeto',
          this.modeloProjetoId,
        )
        this.briefing = await this.$store.dispatch(
          'getBriefingByModeloProjeto',
          this.modeloProjetoId,
        )
        this.$bvModal.show('modalCreateEditModeloProjeto')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async getUsers() {
      try {
        this.users = await this.$store.dispatch('getUsers')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    async getModelosPecas() {
      try {
        this.modelosPecas = await this.$store.dispatch('getModelosPecas')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    async save() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          let response = null
          if (this.modeloProjetoId) {
            response = await this.$store.dispatch('updateModeloProjeto', {
              modeloProjetoId: this.modeloProjetoId,
              modeloProjeto: this.modeloProjeto,
              briefing: this.briefing,
              tarefas: this.tarefas,
              pecas: this.pecas,
            })
          } else {
            response = await this.$store.dispatch('saveModeloProjeto', {
              modeloProjeto: this.modeloProjeto,
              briefing: this.briefing,
              tarefas: this.tarefas,
              pecas: this.pecas,
            })
          }
          this.disableButton = false
          this.$root.$bvToast.toast(response.message, {
            title: 'Sucesso!',
            variant: 'success',
            solid: true,
          })
          this.$emit('closeModal', true)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$bvToast.toast(error.message, {
              title: 'Atenção!',
              variant: 'warning',
              solid: true,
            })
          } else {
            this.$root.$bvToast.toast(
              'Não foi possível se conectar ao servidor.',
              {
                title: 'Erro!',
                variant: 'danger',
                solid: true,
              },
            )
          }
        }
      }
    },
  },

  validations: {
    modeloProjeto: {
      titulo: {
        required,
        minLength: minLength(3),
      },
    },
  },

  mounted() {
    this.getUsers()
    this.getModelosPecas()
    if (this.modeloProjetoId) {
      this.getModeloProjeto()
    } else {
      this.$bvModal.show('modalCreateEditModeloProjeto')
    }
  },
}
</script>
